'use client';

import { useIntl } from 'react-intl';

import style from './TravelersUgcSectionTitle.module.css';

export function TravelersUgcSectionTitle() {
    const { formatMessage } = useIntl();

    return (
        <div className={style.container}>
            <h2 className={style.title}>
                {formatMessage({
                    id: 'page.home.ugcSection.ugcSubtitle',
                })}
            </h2>
        </div>
    );
}
